import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '~environment';
import { HttpRequestService } from '../../../../app/shared/servicios/HttpRequestService';
import { AuthService } from '../../../../app/shared/servicios/auth.service';

@Injectable({
  providedIn: 'root'
})
export class SalesService {

  constructor(
    private http: HttpClient,
    private httpRequestService: HttpRequestService,
    private route: ActivatedRoute,
    private authService: AuthService,
  ) { }

  private readonly apiTriidyUrlSales = `${environment.apiTriidyUrlSales}`;
  private readonly triidyServiceUrl = `${environment.apiTriidyUrl}`;
  private readonly triidyServiceUrlRest = `${environment.apiTriidyUrlRestSales}/api`;
  private readonly triidyServiceLogistics = `${environment.apiTriidyUrlLogistics}/api`;
  private readonly triidyServiceProducts = `${environment.apiTriidyUrlProduct}/api`;
  private readonly triidyServiceUrlRestSale = `${environment.apiTriidyUrlVentas}/api`;

  token = environment.serviceToken;
  idTienda = atob(this.authService.leerIdTienda());
  dataUserLog = atob(this.authService.leerUserLog());
  dataUserName = atob(this.authService.leerNombre());
  dataStore = atob(this.authService.leerTienda());
  key = atob(this.authService.leerToken());
  boost = atob(this.authService.leerBoost());

  private subject = new Subject<any>();

  sendDataLastSaleEvent(phone, idPedido): any {
    if (phone) {
      this.getLastSale(phone).subscribe((event) => {
        if (event[0].id_response && event[0].id_response === '1001') {
          this.subject.next(event[0])
        } else {
          this.getDataDetailandSaleNews(event[0].id_registro, event);
        }
      })
    }
    if (idPedido) {
      this.getDataDetailandSaleNews(idPedido, null)
    }
  }

  getDataDetailandSaleNews(idPedido: any, event: any): void {
    this.getDetailSale(idPedido).subscribe((dataDetailSale) => {
      this.getDetailSaleNews(idPedido).subscribe((dataNews) => {
        this.subject.next({ lastSale: event != null ? event : null, detailLastSale: dataDetailSale, novelties: dataNews })
      })
    })
  }

  getDataLastSaleEvent(): Observable<any> {
    return this.subject.asObservable();
  }

  getClient(telefono: string): Observable<any[]> {
    const codigo_pais = atob(sessionStorage.getItem(btoa('countrySelected')));
    const params = this.httpRequestService.getHttpParamsRequestParams({
      token: this.token,
      codigo_pais,
      telefono,
    });
    return this.http
      .get<any[]>(`${this.apiTriidyUrlSales}/GetCliente`, {
        params,
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getCities(): Observable<any[]> {
    const codigo_pais = atob(sessionStorage.getItem(btoa('countrySelected')));
    const params = this.httpRequestService.getHttpParamsRequestParams({
      token: this.token,
      id_tienda: this.idTienda,
      codigo_pais
    });
    return this.http
      .get<any[]>(`${this.apiTriidyUrlSales}/GetCiudades`, {
        params,
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getProductsAvailable(idCity: String, type: String, idProvider: String, conveyor: String): Observable<any[]> {
    const codigo_pais = atob(sessionStorage.getItem(btoa('countrySelected')));
    const id_tiendaIn = atob(this.authService.leerIdTienda());
    const params = this.httpRequestService.getHttpParamsRequestParams({
      token: this.token,
      id_tienda: id_tiendaIn,
      id_ciudad_destino: idCity,
      tipo_consulta: type,
      id_proveedor: idProvider,
      transportadora: conveyor,
      codigo_pais
    });
    return this.http
      .get<any[]>(`${this.apiTriidyUrlSales}/ProductosDisponibles`, {
        params,
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getProductDetail(id: any): Observable<any> {
    const token = environment.serviceToken;
    const tienda = atob(this.authService.leerIdTienda());

    const params = this.httpRequestService.getHttpParamsRequestParams({
      id_producto: id,
      token: token,
      id_tienda: tienda
    });
    return this.http
      .get<any>(`${this.apiTriidyUrlSales}/GetProducto_venta_final`, {
        params,
      })
      .pipe(
        map((resp) => {
          // console.log(resp)
          return resp;
        })
      );
  }

  getSelfProductDetail(id: any): Observable<any> {
    const token = environment.serviceToken;
    const params = this.httpRequestService.getHttpParamsRequestParams({
      id,
      token,
    });
    return this.http
      .get<any>(`${this.triidyServiceUrl}/GetProductoPropio`, {
        params,
      })
      .pipe(
        map((resp) => {
          return resp;
        })
      );
  }

  getCityDetail(id_ciudad: any): Observable<any> {
    const token = environment.serviceToken;
    const tienda = atob(this.authService.leerIdTienda());

    const id_tienda = tienda
    const params = this.httpRequestService.getHttpParamsRequestParams({
      id_tienda,
      id_ciudad,
      token,
    });
    return this.http
      .get<any>(`${this.apiTriidyUrlSales}/GetCiudad`, {
        params,
      })
      .pipe(
        map((resp) => {
          return resp;
        })
      );
  }

  getCityNotification(idCity: String): Observable<any[]> {
    const params = this.httpRequestService.getHttpParamsRequestParams({
      token: this.token,
      id_ciudad_destino: idCity,
    });
    return this.http
      .get<any[]>(`${this.apiTriidyUrlSales}/NotificacionesCiudad`, {
        params,
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getBoostNotification(idCity: String): Observable<any[]> {
    const tienda = atob(this.authService.leerIdTienda());

    const params = this.httpRequestService.getHttpParamsRequestParams({
      token: this.token,
      id_municipio: idCity,
      id_tienda: tienda
    });
    return this.http
      .get<any[]>(`${this.apiTriidyUrlSales}/validaciones_boost`, {
        params,
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  saveClient(clientData: any): Observable<any[]> {
    const token = environment.serviceToken;
    clientData.token = token;
    clientData.codigo_pais = atob(sessionStorage.getItem(btoa('countrySelected')));
    // console.log(clientData)
    return this.http
      .post<any>(`${this.triidyServiceUrlRest}/Clientes`, clientData)
      .pipe(
        map((respuesta) => {
          return respuesta;
        }, (err) => {
          console.log(err);
        })
      );
  }

  sendSaleCreated(saleData: any): Observable<any[]> {
    const tienda = atob(this.authService.leerIdTienda());

    const token = environment.serviceToken;
    saleData.token = token;
    saleData.key = this.key;
    saleData.id_tienda = tienda;
    saleData.formulario = 'v1';
    // console.log(saleData);
    return this.http
      .post<any>(`${this.triidyServiceUrlRestSale}/GenerarVenta`, saleData)
      .pipe(
        map((respuesta) => {
          // console.log(respuesta)
          return respuesta;
        }, (err) => {
          console.log(err);
        })
      );
  }

  getCalcDelivery(deliveryData: any): Observable<any[]> {
    // console.log(deliveryData)
    const token = environment.serviceToken;
    deliveryData.token = token;
    return this.http
      .post<any>(`${this.triidyServiceLogistics}/cotizador`, deliveryData)
      .pipe(
        map((respuesta) => {
          return respuesta;
        }, (err) => {
          console.log(err);
        })
      );
  }

  getCalcDelivery2(deliveryData: any): Observable<any[]> {
    // console.log(deliveryData)
    const token = environment.serviceToken;
    deliveryData.token = token;
    return this.http
      .post<any>(`${this.triidyServiceLogistics}/CotizadorGeneral`, deliveryData)
      .pipe(
        map((respuesta) => {
          return respuesta;
        }, (err) => {
          console.log(err);
        })
      );
  }

  getDetailSale(orderNumber: string): Observable<any[]> {
    const tienda = atob(this.authService.leerIdTienda());

    const body = {
      id_tienda: tienda,
      id_pedido: orderNumber,
      key: this.key
    };
    // console.log(body)
    return this.http
      .post<any>(`${this.triidyServiceUrlRestSale}/GetDetalleVenta`, body)
      .pipe(
        map((respuesta) => {
          // console.log(respuesta);
          return respuesta;
        }, (err) => {
          //console.log(err);
        })
      );
  }

  getLastSale(phone: string): Observable<any[]> {
    const tienda = atob(this.authService.leerIdTienda());

    const params = this.httpRequestService.getHttpParamsRequestParams({
      token: this.token,
      id_tienda: tienda,
      usuario: this.dataUserLog,
      telefono: phone
    });
    return this.http
      .get<any[]>(`${this.apiTriidyUrlSales}/GetUltimaCompra`, {
        params,
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getDetailSaleNews(orderNumber: string): Observable<any[]> {
    const tienda = atob(this.authService.leerIdTienda());

    const body = {
      id_tienda: tienda,
      id_registro: orderNumber,
      key: this.key
    };
    // console.log(body)
    return this.http
      .post<any>(`${this.triidyServiceUrlRestSale}/GetDetalleVentaNovedad`, body)
      .pipe(
        map((respuesta) => {
          // console.log(respuesta);
          return respuesta;
        }, (err) => {
          //console.log(err);
        })
      );
  }

  createDetailSaleNews(orderNumber: string, novelty: string): Observable<any[]> {
    const tienda = atob(this.authService.leerIdTienda());

    const body = {
      key: this.key,
      id_tienda: tienda,
      id_pedido: orderNumber.toString(),
      novedad: novelty,
      es_solucion: 'NO'
    };
    // console.log(body)
    return this.http
      .post<any>(`${this.triidyServiceUrlRestSale}/CrearNovedad`, body)
      .pipe(
        map((respuesta) => {
          // console.log(respuesta);
          return respuesta;
        }, (err) => {
          //console.log(err);
        })
      );
  }

  requestCancellation(orderNumber: string): Observable<any[]> {
    const tienda = atob(this.authService.leerIdTienda());

    const body = {
      id_tienda: tienda,
      id_pedido: orderNumber,
      key: this.key
    };
    // console.log(body)
    return this.http
      .post<any>(`${this.triidyServiceUrlRestSale}/SolicitarAnulacion`, body)
      .pipe(
        map((respuesta) => {
          // console.log(respuesta);
          return respuesta;
        }, (err) => {
          //console.log(err);
        })
      );
  }

  getDisputeList(orderNumber: string): Observable<any[]> {
    const token = environment.serviceToken;
    const tienda = atob(this.authService.leerIdTienda());

    const params = this.httpRequestService.getHttpParamsRequestParams({
      token: token,
      key: this.key,
      id_tienda_login: tienda,
      id_pedido: orderNumber,
    })
    return this.http
      .get(`${this.apiTriidyUrlSales}/DetalleDisputa`, { params, 'responseType': 'text' })
      .pipe(
        map((respuesta) => {
          var resTransform = respuesta.replace('][', ']/|/[').split('/|/')
          if (JSON.parse(resTransform[0])[0].response) return JSON.parse(resTransform[0])[0]
          var dataParsed = { disputeList: JSON.parse(resTransform[0]), status: JSON.parse(resTransform[1]) }
          return dataParsed;
        }, (err) => {
          console.log(err);
        })
      );
  }

  createDispute(orderNumber: string, dispute: string): Observable<any[]> {
    const token = environment.serviceToken;
    const tienda = atob(this.authService.leerIdTienda());

    const params = this.httpRequestService.getHttpParamsRequestParams({
      token: token,
      key: this.key,
      id_tienda_login: tienda,
      id_pedido: orderNumber.toString(),
      disputa: dispute
    })
    return this.http
      .get<any[]>(`${this.apiTriidyUrlSales}/RegistrarDisputa`, { params })
      .pipe(
        map((respuesta) => {
          return respuesta;
        }, (err) => {
          console.log(err);
        })
      );
  }

  createCancellation(orderNumber: string, reason: string): Observable<any[]> {
    const tienda = atob(this.authService.leerIdTienda());

    const body = {
      key: this.key,
      id_tienda: tienda,
      id_registro: orderNumber.toString(),
      motivo: reason
    };
    // console.log(body)
    return this.http
      .post<any>(`${this.triidyServiceUrlRestSale}/AnularGuia`, body)
      .pipe(
        map((respuesta) => {
          // console.log(respuesta);
          return respuesta;
        }, (err) => {
          //console.log(err);
        })
      );
  }

  returnGuide(orderNumber: string, reason: string): Observable<any[]> {
    const tienda = atob(this.authService.leerIdTienda());

    const body = {
      key: this.key,
      id_tienda: tienda,
      id_registro: orderNumber.toString(),
      motivo: reason
    };
    // console.log(body)
    return this.http
      .post<any>(`${this.triidyServiceUrlRestSale}/DevolverGuia`, body)
      .pipe(
        map((respuesta) => {
          // console.log(respuesta);
          return respuesta;
        }, (err) => {
          //console.log(err);
        })
      );
  }

  getCalificacionClientes(telefono, id_producto): Observable<any> {
    const token = environment.serviceToken;
    const json = 'SI';
    const params = this.httpRequestService.getHttpParamsRequestParams({
      telefono,
      id_producto,
      token,
      json
    });
    return this.http
      .get<any>(`${this.apiTriidyUrlSales}/CalificacionClientes`, {
        params,
      })
      .pipe(
        map((resp) => {
          return resp;
        })
      );
  }


  // Administration guides section

  getStores(): Observable<any[]> {
    const token = environment.serviceToken;
    const tienda = atob(this.authService.leerIdTienda());
    const params = this.httpRequestService.getHttpParamsRequestParams({
      token: token,
      id_tienda_login: tienda,
      key: this.key
    })
    return this.http
      .get<any>(`${this.triidyServiceUrl}/GetTiendasVisibles`, { params })
      .pipe(
        map((respuesta) => {
          return respuesta;
        }, (err) => {
          console.log(err);
        })
      );
  }

  getSeller(storeSelected: string): Observable<any[]> {
    const tienda = atob(this.authService.leerIdTienda());

    const body = {
      id_tienda_login: tienda,
      id_tienda: storeSelected,
      key: this.key
    };
    // console.log(body)
    return this.http
      .post<any>(`${this.triidyServiceUrlRest}/GetVendedores`, body)
      .pipe(
        map((respuesta) => {
          // console.log(respuesta);
          return respuesta;
        }, (err) => {
          //console.log(err);
        })
      );
  }

  getGuides(dataToSearch: any): Observable<any[]> {
    dataToSearch.token = environment.serviceToken;
    dataToSearch.key = this.key;
    dataToSearch.id_tienda_login = atob(this.authService.leerIdTienda());
    const codigo_pais = atob(sessionStorage.getItem(btoa('countrySelected')));
    const body = {
      id_tienda_login: dataToSearch.id_tienda_login,
      id_tienda: dataToSearch.id_tienda,
      fecha_inicio: dataToSearch.fecha_inicio,
      fecha_fin: dataToSearch.fecha_fin,
      tipo_consulta: dataToSearch.tipo_consulta,
      estado: dataToSearch.estado,
      variantes: dataToSearch.variantes,
      vendedor_user: dataToSearch.vendedor_user,
      token: dataToSearch.token,
      key: dataToSearch.key,
      codigo_pais
    };
    // console.log(body)
    return this.http
      .post<any>(`${this.triidyServiceUrlRestSale}/ConsultarGuias`, body)
      .pipe(
        map((respuesta) => {
          return respuesta;
        }, (err) => {
          //console.log(err);
        })
      );
  }

  linkCheckout(nombre2, email2, cedula2, telefono2, id_registro2, detalle_venta2, total2, ip2, userAgent2): Observable<any[]> {
    const token = environment.serviceToken;
    const key = atob(this.authService.leerToken());
    const id_tienda = atob(this.authService.leerIdTienda());
    let detail = JSON.parse(detalle_venta2);
    // console.log(detail[0].detalle)
    const body = {
      key: key,
      id_tienda_login: id_tienda,
      token: token,
      nombre_cliente: nombre2,
      email: email2,
      cedula: cedula2,
      telefono: telefono2,
      id_registro: id_registro2,
      referencia: id_registro2,
      detalle_venta: detail[0].detalle,
      total: total2,
      ip: ip2,
      user_agent: userAgent2,
      tipo_link: 'Guia'
    };
    // console.log(body)
    return this.http
      .post<any>(`${this.triidyServiceUrlRest}/WebCheckout`, body)
      .pipe(
        map((respuesta) => {
          // console.log(respuesta);
          return respuesta;
        }, (err) => {
          //console.log(err);
        })
      );
  }

  getIP(): Observable<any[]> {
    const params = this.httpRequestService.getHttpParamsRequestParams({
      key: this.key
    })
    return this.http
      .get<any>(`${this.triidyServiceUrl}/GetIP`, { params })
      .pipe(
        map((respuesta) => {
          return respuesta;
        }, (err) => {
          console.log(err);
        })
      );
  }

  envioSMS(celularIn, tienda, url): Observable<any[]> {
    const token = environment.serviceToken;
    const indicativoConst = '+' + atob(sessionStorage.getItem(btoa('countrySelected')));
    const providerConst = 'AWS';
    const mensajeConst = 'Link de pago para tu compra en ' + tienda + ' ' + url;
    const celularConst = celularIn;
    const body = {
      token: token,
      indicativo: indicativoConst,
      celular: celularConst,
      mensaje: mensajeConst,
      provider: providerConst
    };
    // console.log(body)
    return this.http
      .post<any>(`${this.triidyServiceUrlRest}/SendSMS`, body)
      .pipe(
        map((respuesta) => {
          // console.log(respuesta);
          return respuesta;
        }, (err) => {
          //console.log(err);
        })
      );
  }

  recortadorURL(url): Observable<any[]> {
    const keyIn = atob(this.authService.leerToken());
    const id_tiendaIn = atob(this.authService.leerIdTienda());
    const body = {
      key: keyIn,
      id_tienda: id_tiendaIn,
      cadena_larga: url
    };
    // console.log(body)
    return this.http
      .post<any>(`${this.triidyServiceUrlRest}/Bitly`, body)
      .pipe(
        map((respuesta) => {
          // console.log(respuesta);
          let resp = respuesta[0].respuesta.replace('\n', '')
          return resp;
        }, (err) => {
          //console.log(err);
        })
      );
  }

  ProductSalesValidate(id_productoIn, transportadoraIn): Observable<any[]> {
    const keyIn = atob(this.authService.leerToken());
    const cod_paisIn = atob(sessionStorage.getItem(btoa('countrySelected')));

    const body = {
      key: keyIn,
      id_producto: id_productoIn,
      transportadora: transportadoraIn,
      cod_pais: cod_paisIn
    };

    return this.http
      .post<any>(`${this.triidyServiceProducts}/ProductSalesValidate`, body)
      .pipe(
        map((respuesta) => {
          return respuesta;
        }, (err) => {
          console.log(err);
        })
      );
  }

  resumeSalesCostService(valueSale: any, idProduct: any, payMethod: any): Observable<any[]> {
    const keyIn = atob(this.authService.leerToken());
    const idStoreIn = atob(this.authService.leerIdTienda());
    const cod_paisIn = atob(sessionStorage.getItem(btoa('countrySelected')));

    const body = {
      key: keyIn,
      id_tienda: idStoreIn,
      valor_venta: valueSale,
      id_productos: idProduct,
      metodo_pago: payMethod,
      pais_destinatario: cod_paisIn
    };

    return this.http
      .post<any>(`${this.triidyServiceUrlRestSale}/ResumenCostoVenta`, body)
      .pipe(
        map((respuesta) => {
          return respuesta;
        }, (err) => {
          console.log(err);
        })
      );
  }

  oficceCourier(id_ciudad): Observable<any[]> {
    const key = atob(this.authService.leerToken());

    const params = this.httpRequestService.getHttpParamsRequestParams({
      key,
      id_ciudad,
    })
    return this.http
      .get<any>(`${this.triidyServiceLogistics}/OficinasCourier`, { params })
      .pipe(
        map((respuesta) => {
          return respuesta;
        }, (err) => {
          console.log(err);
        })
      );
  }
}
